import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { STOCK_BALANCE } from '../types/stock-balance.js';
/**
 * Descriptor for StockBalance — aggregate (variant × location), request 0107.
 * Mutated only by the ledger store (ADR §D8).
 */
export const stockBalanceDescriptor = {
    name: STOCK_BALANCE,
    label: 'Saldo de Estoque',
    domain: 'stock',
    collectionPath: 'org/{orgId}/stock-balance',
    pathPatternKeys: { orgId: 'string' },
    version: 3,
    description: 'Aggregate stock balance per (reference, location) — no lot',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    writePolicy: 'readonly',
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        { name: 'productId', label: 'Produto', type: 'string', required: true },
        { name: 'variantId', label: 'Variante', type: 'string', required: false },
        { name: 'stockLocationId', label: 'Local', type: 'string', required: true },
        {
            name: 'ownerPartyId',
            label: 'Proprietário',
            type: 'string',
            required: false,
            description: 'FK → Party; null = estoque próprio (0044)',
        },
        { name: 'quantity', label: 'Saldo', type: 'number', display: 'quantity', required: true },
        {
            name: 'reservedQuantity',
            label: 'Reservado',
            type: 'number',
            display: 'quantity',
            required: true,
            description: 'Lot-agnostic reserved quantity',
        },
        {
            name: 'lastMovementAt',
            label: 'Última movimentação',
            type: 'date',
            display: 'datetime',
            required: false,
        },
        { name: 'updatedAt', label: 'Atualizado em', type: 'date', display: 'datetime', required: false },
    ],
    foreignKeys: [
        {
            fieldName: 'productId',
            targetEntity: 'Product',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'variantId',
            targetEntity: 'ProductVariant',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'stockLocationId',
            targetEntity: 'StockLocation',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'ownerPartyId',
            targetEntity: 'Party',
            relationship: 'many-to-one',
            displayField: 'displayName',
        },
    ],
};
//# sourceMappingURL=stock-balance.descriptor.js.map